import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/virtual_contracts",
	lazy(() => import("./AdminSavedVCPage"))
);
